import React from 'react';
import ClipboardListIcon from '@heroicons/react/outline/ClipboardListIcon.js';
import { BlockType } from '../../types/index.js';
import { ComposerBlock as Component } from './Block.js';
export const RegisteredComposerBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'Composer',
        Component,
        config: {
            type: BlockType.Block,
            displayName: $t({
                id: 'Blocks.Composer.DisplayName',
                defaultMessage: 'Composer',
            }),
            Icon: React.createElement(ClipboardListIcon, null),
        },
    };
};
//# sourceMappingURL=registered.js.map